"use client"; // Ensure compatibility with Next.js App Router

import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import Button from "@/components/CommonComponent/button";
import styled from 'styled-components'
import Image from "next/image";
import Slider from "react-slick";
import { FaChevronUp, FaChevronDown, FaUserCircle } from "react-icons/fa";
import { MdOutlineVerified } from "react-icons/md";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { MdOutlineStar } from 'react-icons/md';
import DynamicPoints from '@/Data/RandomPoints.json'
const Banner = ({ image_alt, image, text1, link1, text2, link2, title, description, cluth }: any) => {
    const sliderRef = useRef<Slider | null>(null); // Specify correct ref type
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false, // Hide default arrows
    };
    const settings1 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 640, settings: { slidesToShow: 1 } },
        ],
    };
    const renderStars = (rating: number) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            if (i < rating) {
                stars.push(<MdOutlineStar key={i} className="text-pink text-[18px]" />);
            } else {
                stars.push(<MdOutlineStar key={i} className="text-gray-300 text-[18px]" />);
            }
        }
        return stars;
    };
    const [randomPoints, setRandomPoints] = useState<any>();
    useEffect(() => {
        const shuffled = DynamicPoints.statistics.sort(() => 0.5 - Math.random());
        setRandomPoints(shuffled.slice(0, 3));
    }, []);
    return (
        <div className=" bg-[url('/images/priya/banner1-bg.svg')] bg-center bg-cover bg-no-repeat">
            <div className="flex flex-col justify-center w-full h-fit py-4 bg-center">
                <div className="mx-auto xl:w-[95%] 2xl:w-[80%] px-6 flex justify-center">
                    <div className="flex justify-between flex-wrap lg:flex-nowrap  items-start py-4 md:py-10 gap-7">
                        <div className=" w-fit  !lg:w-1/2 items-center lg:items-start flex flex-col gap-6">
                            <h1 className=" text-white  font-bold">
                                {title || ''}
                            </h1>

                            <StyledWrapper>
                                <div className="!text-white text-[20px]" dangerouslySetInnerHTML={{ __html: description || '' }}>
                                </div></StyledWrapper>
                            {/* <div className="relative  w-full hidden sm:block max-w-[345px] sm:max-w-[445px] ">
                                <div className="absolute sm:top-1/2   sm:right-[-50px] transform -translate-y-1/2 flex flex-col gap-2">
                                    <button
                                        className="p-2 bg-white rounded-full shadow-md "
                                        onClick={() => sliderRef.current?.slickPrev()}
                                    >
                                        <BsArrowUp
                                            className="text-pink text-[20px] font-semibold" />
                                    </button>
                                    <button
                                        className="p-2 bg-white rounded-full shadow-md "
                                        onClick={() => sliderRef.current?.slickNext()}
                                    >
                                        <BsArrowDown className="text-pink text-[20px]  font-semibold" />
                                    </button>
                                </div>
                                <Slider ref={sliderRef} {...settings}>
                                    {cluth?.map((testimonial: any, index: number) => (
                                        <div key={index} className="p-6 !flex  gap-4 items-start justify-between bg-white rounded-lg shadow-md">
                                            <div className="md:w-1/2">
                                                <div className="flex  gap-4">
                                                    <span className="min-w-10 min-h-10 mt-2">
                                                        <FaUserCircle className="text-homegrey text-[38px]" />
                                                    </span>
                                                    <div>
                                                        <span className="font-semibold">{testimonial?.position}</span>
                                                    </div>
                                                </div>
                                                <div className='flex my-1 text-pink items-center text-[20px]'>{testimonial?.rating || 5.0}
                                                    {renderStars(testimonial?.rating || 5)}
                                                </div>
                                                <div className="flex items-center gap-1"><MdOutlineVerified />
                                                    Verified Review</div>
                                            </div>
                                            <div className=" w-1/2 text-gray-700">{testimonial?.review}</div>
                                        </div>
                                    ))}
                                </Slider>
                            </div> */}
                            <div className="flex  gap-3 justify-center md:justify-start sm:gap-5">
                                <Link href={link1 || ''}>
                                    <Button content={text1} />
                                </Link>
                                {/* {
                                    link2 &&
                                    <Link href={`/${link2}` || ''}>
                                        <Button content={text2} />
                                    </Link>
                                } */}
                                {
                                    link2 && text2 && (
                                        link2.includes('tel:') ? (
                                            <a href={link2}>
                                                <Button content={text2}></Button>
                                            </a>
                                        ) :
                                            (
                                                link2.includes('http') ? (
                                                    <Link href={link2} target="_blank" rel="noopener noreferrer">
                                                        <Button content={text2} />
                                                    </Link>
                                                ) : (
                                                    <Link href={`/${link2}`} passHref>
                                                        {/* <a> */}
                                                        <Button content={text2} />
                                                        {/* </a> */}
                                                    </Link>
                                                )
                                            )

                                    )
                                }
                            </div>
                        </div>
                        <div className="w-full  flex justify-center !lg:w-1/2 rounded-lg lg:block">
                            <div>
                                {
                                    image && (
                                        <div className="flex justify-center">
                                            <Image src={image || ''} alt={image_alt} height={490} width={490} />
                                        </div>
                                    )
                                }
                                <div className="flex w-full mt-6 justify-center gap-2 sm:gap-3 flex-wrap">
                                    {randomPoints?.map((point: any, index: number) => (
                                        <div
                                            key={index}
                                            className="flip-card mt-10 sm:mt-0 min-w-[180px] size-[180px]  min-h-[180px]"
                                        >
                                            <div className="flip-card-inner">
                                                <div className="flip-card-front flex items-center justify-center p-2 text-center">
                                                    <Image src={'/case-study/tick_banner.svg'} alt={image_alt} height={100} width={100} className="absolute z-50 -top-10 left-10" />
                                                    <div className="title  text-[14px] "> <span className="text-[28px] text-blue">{point?.value}</span> <br />{point?.title}</div>
                                                </div>
                                                <div className="flip-card-back flex items-center justify-center p-2 text-center">
                                                    <Image
                                                        src="/case-study/tick_banner.svg"
                                                        alt="Tick Back"
                                                        height={100}
                                                        width={100}
                                                        className="absolute z-50 -top-10 right-10"
                                                    />
                                                    <div className="title text-[14px] "> {point?.description}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // </div>
    );
};

export default Banner;

export const StyledWrapper = styled.div`

   ul {
    list-style: disc;
  }
  h1,h2,h6,h3,h4,h5,h6 {
      color: #333333;
  }
      strong{
      color: #333333;
      }
 p ,li ,td {
  color: #FFF; /* Replace with your color */
}
  ol, ul {
    padding-left: 1.5rem;
    list-style-type:disc;
    color: #FFF;
    font-size:20px!important;
  }
    strong{
        color: #FFF;
    }
 `